import { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '@features/auth';

import LoadingSpinner from '@/shared/ui/LoadingSpinner/LoadingSpinner';
import { PROTECTED_ROUTES, USER_ROLES } from '@/shared/constants';

interface UserAccessGuardProps {
    children: ReactNode;
    accessType?: string;
}

const UserAccessGuard = ({ children, accessType = 'profile' }: UserAccessGuardProps): ReactNode => {
    const { user, userProfile, loading } = useAuth();
    const params = useParams<{ userId?: string; certificateId?: string }>();
    const requestedUserId = params.userId || params.certificateId;

    if (loading) {
        return <LoadingSpinner fullScreen text="Loading..." />;
    }

    if (!user) {
        console.warn('[UserAccessGuard] No user, redirecting to /login');
        return <Navigate to="/login" replace />;
    }

    if (!userProfile) {
        console.warn('[UserAccessGuard] No userProfile, redirecting to dashboard');
        return <Navigate to={PROTECTED_ROUTES.DASHBOARD} replace />;
    }

    const isAdmin = userProfile.role === USER_ROLES.DMV_ADMIN || userProfile.role === USER_ROLES.SUPER_ADMIN;
    const isOwnResource = user.uid === requestedUserId;

    if (!isOwnResource && !isAdmin) {
        console.warn('[UserAccessGuard] Unauthorized access attempted, redirecting to dashboard');
        return <Navigate to={PROTECTED_ROUTES.DASHBOARD} replace />;
    }

    return children;
};


export default UserAccessGuard;
